exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-gops.js
// module id = 224
// module chunks = 0 1 2 3 4